import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";
const { mediaQuery: breakpoint } = mediaQueryStyles;
const { textMObj } = typographyStyles;

export const summaryInfoContentCss = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  marginTop: "24px",
};

export const wordLinkCss = {
  ...textMObj,
  marginBottom: "16px",
  fontWeight: "400",
  lineHeight: "16px",
  color: "#04337A",
};

export const textScoreCss = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#FFF8ED",
  borderRadius: "8px",
  width: "90%",
  height: "40px",
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "23.94px",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.md)]: {
    maxWidth: "300px",
  },
};
